import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
	const [dark, setDark] = useState(() => {
		const saved = localStorage.getItem('pf-dark');
		return saved === 'true';
	});

	useEffect(() => {
		const html = document.documentElement;
		if (dark) {
			html.classList.add('pf-dark');
		} else {
			html.classList.remove('pf-dark');
		}
		localStorage.setItem('pf-dark', dark);
	}, [dark]);

	const toggleTheme = () => setDark(prev => !prev);

	return (
		<ThemeContext.Provider value={{ dark, toggleTheme }}>
			{children}
		</ThemeContext.Provider>
	);
};

export const useTheme = () => useContext(ThemeContext);
